// 原因应该用的 orderActionData.message 然后结果 用的是orderActionData.statusDetail.reason
export let inTableLabels = [{
  label: '客户样本编号',
  value: 'sampleId'
}, {
  label: '样本类型',
  value: 'sampleType.name'
}]
export let outTableLabels = [{
  label: '客户样本编号',
  value: 'sampleId'
}, {
  label: '客户产品',
  value: 'productName'
}, {
  label: '样本类型',
  value: 'sampleType.name'
}, {
  label: '接收单位', // 下一状态
  value: 'clientInfo.fullName',
  minWidth: '100'
}]
export let ALLTableLabels = outTableLabels
export let filterFactor = [{
  label: '接收单位',
  type: 'select',
  clearable: true,
  value: 'clientInfoId', // 需返回数据的字段名
  options: []
}]
